import AddIcon from "@mui/icons-material/Add";
import { Grid } from "@mui/material";
import AcxButton from "components/UI/AcxButton";
import { observer } from "mobx-react";
import React from "react";
import { AuthStore } from "stores/AuthStore";
import { useStore } from "utils/useStore";
import OrganizationWorkflowEmailStore from "./Stores/OrganizationWorkflowEmailStore";
import OrganizationWorkflowsStore from "./Stores/OrganizationWorkflowsStore";
import theme from "Theme/AppTheme";

type Props = {
    conditionStore: OrganizationWorkflowsStore;
    emailStore: OrganizationWorkflowEmailStore;
};

const OrganizationWorkflowsActionBar: React.FC<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = observer(({ conditionStore, emailStore }) => {
    const authStore = useStore(AuthStore);

    return (
        <Grid container item xs={12}>
            <Grid
                item
                xs={12}
                sx={{
                    padding: "0.5rem 0",
                    display: "flex",
                    alignItems: "center",
                }}
            >
                <AcxButton
                    disabled={
                        !authStore.canUserEdit("Workflow Conditions") ||
                        conditionStore.isCreateDisabled
                    }
                    color="primary"
                    style={{
                        padding: "1rem",
                        minWidth: "max-content",
                    }}
                    startIcon={<AddIcon />}
                    onClick={() => emailStore.setEmailEditorIsOpen(true)}
                >
                    Create Email
                </AcxButton>

                <AcxButton
                    disabled={
                        !authStore.canUserEdit("Workflow Conditions") ||
                        conditionStore.isCreateDisabled
                    }
                    color="primary"
                    style={{
                        padding: "1rem",
                        minWidth: "max-content",
                        marginRight: theme.spacing(1),
                        marginLeft: theme.spacing(1),
                    }}
                    startIcon={<AddIcon />}
                    onClick={conditionStore.handleDrawerOpen}
                >
                    Create Condition
                </AcxButton>
            </Grid>
        </Grid>
    );
});

export default OrganizationWorkflowsActionBar;
